import React, { useEffect, useRef, useState } from 'react';

import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Button, Modal, Form } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import axios from 'axios';
import swal from 'sweetalert';
import { API_URL } from '..';
import MasterLayout from '../masterLayout/MasterLayout';
const Accounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formData, setFormData] = useState({ title: '' });
  const [editAccount, setEditAccount] = useState(null);
  const [errors, setErrors] = useState({});
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
    } else {
      fetchAccounts();
    }

    return () => {
      if (dataTableRef.current) {
        dataTableRef.current.destroy(true);
      }
    };
  }, []);

  const fetchAccounts = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    try {
      const response = await axios.get(`${API_URL}/api/accounts/${user.id}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
      });
      if (response.status === 200) {
        setAccounts(response.data.accounts);
        initializeDataTable(response.data.accounts);
      } else {
        swal('Error', response.data.message || 'Failed to fetch accounts', 'error');
      }
    } catch (error) {
      swal('Error', 'Failed to fetch accounts: ' + error.message, 'error');
    }
  };

  const initializeDataTable = (data) => {
    if (dataTableRef.current) {
      dataTableRef.current.destroy(true);
    }

    dataTableRef.current = $(tableRef.current).DataTable({
      data: data,
      columns: [
        { data: 'id', title: 'ID' },
        { data: 'title', title: 'Title' },
        {
          data: 'updatedAt',
          title: 'Updated At',
          render: (data) => new Date(data).toLocaleDateString(),
        },
        {
          data: null,
          title: 'Actions',
          orderable: false,
          searchable: false,
          render: (data, type, row) => `
            <button class="btn btn-sm btn-primary me-2 edit-btn" data-id="${row.id}">
              <i class="bi bi-pencil"></i> Edit
            </button>
            <button class="btn btn-sm btn-danger delete-btn" data-id="${row.id}">
              <i class="bi bi-trash"></i> Delete
            </button>
          `,
        },
      ],
      responsive: true,
      order: [[0, 'desc']],
      pageLength: 10,
    });

    $(tableRef.current).on('click', '.edit-btn', function () {
      const id = $(this).data('id');
      const account = data.find((acc) => acc.id === id);
      setEditAccount(account);
      setFormData({ title: account.title });
      setShowEditModal(true);
    });

    $(tableRef.current).on('click', '.delete-btn', function () {
      const id = $(this).data('id');
      handleDelete(id);
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title.trim()) {
      newErrors.title = 'Account title is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddSubmit = async () => {
    if (!validateForm()) return;    
    const user = JSON.parse(localStorage.getItem('user'));

    try {
      const response = await axios.post(
        `${API_URL}/api/accounts/create`,
        { title: formData.title, affiliate_id: user.id },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        }
      );

      if (response.status === 201) {
        swal('Success', 'Account added successfully', 'success');
        setShowAddModal(false);
        setFormData({ title: '' });
        setErrors({});
        window.location.reload()
      } else {
        swal('Error', response.data.message || 'Failed to add account', 'error');
      }
    } catch (error) {
      swal('Error', 'Failed to add account: ' + error.message, 'error');
    }
  };

  const handleEditSubmit = async () => {
    if (!validateForm()) return;

    try {
      const response = await axios.put(
        `${API_URL}/api/accounts/${editAccount.id}`,
        { title: formData.title },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        }
      );

      if (response.status === 200) {
        swal('Success', 'Account updated successfully', 'success');
        setShowEditModal(false);
        setFormData({ title: '' });
        setEditAccount(null);
        setErrors({});
        window.location.reload()
      } else {
        swal('Error', response.data.message || 'Failed to update account', 'error');
      }
    } catch (error) {
      swal('Error', 'Failed to update account: ' + error.message, 'error');
    }
  };


  const handleDelete = async (id) => {
    const isConfirmed = await swal({
      title: 'Are you sure?',
      text: 'You won’t be able to revert this!',
      icon: 'warning',
      buttons: ['Cancel', 'Yes, delete it!'],
      dangerMode: true,
    });
  
    if (isConfirmed) {
      try {
        const response = await axios.delete(`${API_URL}/api/accounts/${id}`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        });
  
        if (response.status === 200) {
          await swal('Deleted!', 'Account has been deleted.', 'success');
          window.location.reload();
        } else {
          await swal('Error', response.data.message || 'Failed to delete account', 'error');
        }
      } catch (error) {
        await swal('Error', 'Failed to delete account: ' + error.message, 'error');
      }
    }
  };
  

  const handleModalClose = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    setFormData({ title: '' });
    setEditAccount(null);
    setErrors({});

  };

  const handleInputChange = (e) => {
    setFormData({ title: e.target.value });
    setErrors({ ...errors, title: '' });
  };

  return (
    <MasterLayout>
      <div className="container py-5">
    
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                <h6 className="h6 mb-0">Accounts</h6>
                <Button
                  variant="primary"
                  onClick={() => setShowAddModal(true)}
                >
                  <Icon icon="simple-line-icons:plus" className="me-2" />
                  Add Account
                </Button>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    ref={tableRef}
                    className="table table-bordered table-hover"
                    style={{ width: '100%' }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        
                        <th>Updated At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Account Modal */}
      <Modal show={showAddModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Add New Account</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="accountTitle">
              <Form.Label className="fw-bold">Account Title</Form.Label>
              <Form.Control
                type="text"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="Enter account title"
                isInvalid={!!errors.title}
                autoFocus
              />
              <Form.Control.Feedback type="invalid">
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Account Modal */}
      <Modal show={showEditModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Edit Account</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="editAccountTitle">
              <Form.Label className="fw-bold">Account Title</Form.Label>
              <Form.Control
                type="text"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="Enter account title"
                isInvalid={!!errors.title}
                autoFocus
              />
              <Form.Control.Feedback type="invalid">
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEditSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default Accounts;